import { SVGProps, Ref, forwardRef } from 'react';

export const BubbleRoundHyperstarFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8 .5c1.002 0 2.004.086 2.943.278a7 7 0 0 1-.72.557L8.478 2.5l1.747 1.165a8.1 8.1 0 0 1 2.111 2.111L13.5 7.523l1.165-1.747c.301-.451.697-.91 1.128-1.317.133.452.207.95.207 1.496 0 3.196-3.568 5.777-6.44 7.855l-.827.601a25 25 0 0 0-1.4 1.089v-4.103C3.567 11.249 0 9.817 0 5.954 0 1.865 4 .5 8 .5M4.665 6.7h6.665V5.298H4.665z"
                        fill="currentColor"
                    />
                    <path
                        d="M13.5 0A9.5 9.5 0 0 0 16 2.5 9.5 9.5 0 0 0 13.5 5 9.5 9.5 0 0 0 11 2.5 9.5 9.5 0 0 0 13.5 0"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
BubbleRoundHyperstarFilledSize16Glyph.displayName = 'BubbleRoundHyperstarFilledSize16Glyph';
